import { IWorkflowFactoryReviewResponse } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';

/** The Auto-generated review queue: every factory draft awaiting review. Internal-only on the backend
 * (COMMENDA_INTERNAL_USER); a non-internal caller gets a 403 that surfaces as `error`. */
export const useWorkflowFactoryDrafts = () => {
  const url = `${BASE_URL}/review`;

  const { data, error, isLoading, mutate } =
    useSWR<IWorkflowFactoryReviewResponse>(
      url,
      SWRFetcher({
        method: 'GET',
      })
    );

  return { data, error, isLoading, mutate };
};
